import { Avatar, TextArea } from "components/core";
import { FC, useRef } from "react";

import { ChatBubbleOvalLeftEllipsisIcon } from "@heroicons/react/24/outline";
import { FormikProps } from "formik";
import { GetOfferComments_getOfferComments } from "_graphql/queries/kek/__generated__/GetOfferComments";
import { KEKOffer_findSingleOffer } from "_graphql/queries/kek/__generated__/KEKOffer";
import moment from "moment";

type Props = {
  // offers: (Offer_messages_offer_messages | null)[]
  form: FormikProps<any>
  comments: (GetOfferComments_getOfferComments | null)[]
  offer?: KEKOffer_findSingleOffer | null
};

const CommentView: FC<Props> = ({ form, comments, offer }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  return (
    <div className="flex flex-col flex-1 h-[500px] overflow-clip">
      {/* Context header */}
      {/* <div className="px-4 py-3 border-b bg-gray-50 dark:bg-gray-800">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
          {offer
            ? `Comments on ${offer?.offer_detail?.policy_number || "Offer"}`
            : "Offer Comments"}
        </h3>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          These comments are related to the current offer discussion.
        </p>
      </div> */}

      {/* Comments list */}
      <div className="flex h-full flex-1 justify-between overflow-y-scroll no-scrollbar flex-col">
        {comments?.length < 1 ? (
          <div className="flex-1 h-full flex flex-col justify-center items-center space-y-2">
            <ChatBubbleOvalLeftEllipsisIcon className="h-12 w-12 text-gray-400" />
            <p className="text-gray-500 font-medium">No comments yet</p>
            <p className="text-xs text-gray-400">
              Be the first to share your thoughts on this offer.
            </p>
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto no-scrollbar">
            <ul className="space-y-3 px-3">
              {comments.map((activityItem, index) => (
                <li key={activityItem?.created_at + index}>
                  <div className="relative pb-8">
                    {index !== comments.length - 1 ? (
                      <span
                        aria-hidden="true"
                        className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200 dark:bg-white/10"
                      />
                    ) : null}
                    <div className="relative flex items-start space-x-3">
                      <div className="relative">
                        <Avatar alt={activityItem?.employee?.emp_abbrv?.split("").join(" ") || ""} />
                        <span className="absolute -right-1 -bottom-0.5 rounded-tl bg-gray-100 px-0.5 py-px dark:bg-gray-900">
                          <ChatBubbleOvalLeftEllipsisIcon aria-hidden="true" className="size-5 text-gray-400" />
                        </span>
                      </div>
                      <div className="min-w-0 flex-1">
                        <div>
                          <div className="text-sm">
                            <span className="font-medium text-gray-900 dark:text-white">
                              {activityItem?.employee?.employee_first_name} {activityItem?.employee?.employee_last_name}
                            </span>
                          </div>
                          <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">
                            Commented {moment(activityItem?.created_at).calendar({
                              sameDay: '[Today at] h:mm A',
                              nextDay: '[Tomorrow at] h:mm A',
                              nextWeek: 'dddd [at] h:mm A',
                              lastDay: '[Yesterday at] h:mm A',
                              lastWeek: '[Last] dddd [at] h:mm A',
                              sameElse: 'MMMM Do YYYY [at] h:mm A'
                            })}
                          </p>
                        </div>
                        <div className="mt-2 text-sm text-gray-700 dark:text-gray-200">
                          <p>{activityItem?.document_message}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <div ref={messagesEndRef} />
          </div>
        )}
      </div>

      {/* Input */}
      <div className="flex w-full pt-4 border-t ">
        <TextArea
          id="message"
          label=""
          {...form}
          className="w-full"
          placeholder="Type your message here..."
        />
      </div>
    </div>
  );
};


export default CommentView;